const QUERY = `
  query Localisation($countryCode: CountryCode!, $productHandle: String!) @inContext(country: $countryCode) {
    product(handle: $productHandle) {
      variants (first: 100) {
        nodes {
          id
          price {
            amount
            currencyCode
          }
        }
      }
    }
  }
`

class Cache {
  constructor () {
    /** @type {Map<String, String>} */
    this.cache = new Map()
  }

  exists (key) {
    return this.cache.has(key)
  }

  /**
   * @param {String} key
   * @param {String} value
   */
  set (key, value) {
    this.cache.set(key, value)
  }

  /**
   * @param {String} key
   */
  get (key) {
    return this.cache.get(key)
  }

  delete (key) {
    this.cache.delete(key)
  }
}

export class LoyaltyPointsVariant extends window.BAO.CustomElement() {
  static get observedAttributes () {
    return ['data-variant-id']
  }

  static get requiredAttributes () {
    return ['data-country-code', 'data-product-handle', 'data-variant-id']
  }

  constructor () {
    super()

    this.cache = new Cache()
  }

  connectedCallback () {
    super.connectedCallback()

    this.getProductData().then(data => {
      this.log('getProductData', { data })
      this.data = data

      const currentVariantPrice = this.getVariantPrice(
        data,
        this.getVariantId(this.dataset.variantId),
      )
      if (!currentVariantPrice) return

      this.showPointsAmount(parseFloat(currentVariantPrice))
    })
  }

  attributeChangedCallback (name, oldValue, newValue) {
    this.log('attributeChangedCallback', { name, oldValue, newValue })

    switch (name) {
      case 'data-variant-id': {
        if (typeof this.data === 'undefined') return

        const currentVariantPrice = this.getVariantPrice(
          this.data,
          this.getVariantId(newValue),
        )
        this.log('data-variant-id', {
          currentVariantPrice,
          data: this.data,
          variantId: this.getVariantId(newValue),
        })
        if (!currentVariantPrice) return

        this.showPointsAmount(parseFloat(currentVariantPrice))
      }
    }
  }

  async getProductData () {
    return this.makeStorefrontRequest({
      body: JSON.stringify({
        query: QUERY,
        variables: {
          countryCode: window.theme.defaultIsoCode,
          productHandle: this.productHandle,
        },
      }),
    })
  }

  getVariantPrice (data, variantId) {
    this.log('getVariantPrice', { data, variantId })
    const variant = data.product.variants.nodes.find(
      variant => variant.id === variantId,
    )

    return variant?.price?.amount
  }

  showPointsAmount (amount) {
    this.textContent = (
      (amount ?? 0.0 / 100) * window.theme.pointsMultiplier
    ).toString()
  }

  /**
   * @param {RequestInit} options
   */
  async makeStorefrontRequest (options) {
    if (this.cache.exists(this.getCacheKey())) {
      return this.cache.get(this.getCacheKey())
    }

    try {
      const { data } = await window.BAO.Utils.fetchJSON(
        `/api/2024-01/graphql.json`,
        Object.assign(
          {},
          {
            method: 'POST',
            headers: {
              Accept: `application/json`,
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token':
                window.theme.storefrontAccessToken,
            },
          },
          options,
        ),
      )

      this.cache.set(this.getCacheKey(), data)

      this.setAttribute('aria-busy', false)

      return data
    } catch (e) {
      console.error(e)
    }
  }

  getCacheKey () {
    return `${this.countryCode}-${this.productHandle}`
  }

  getVariantId (variantId) {
    return `gid://shopify/ProductVariant/${variantId}`
  }

  get countryCode () {
    return this.dataset.countryCode
  }

  get productHandle () {
    return this.dataset.productHandle
  }
}

if (!customElements.get('loyalty-points-variant')) {
  customElements.define('loyalty-points-variant', LoyaltyPointsVariant)
}
